import { render, staticRenderFns } from "./FormOptionDetailsBox.vue?vue&type=template&id=3bd7abc0&scoped=true&"
import script from "./form-option-details-box.js?vue&type=script&lang=js&"
export * from "./form-option-details-box.js?vue&type=script&lang=js&"
import style0 from "./form-option-details-box.scss?vue&type=style&index=0&id=3bd7abc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd7abc0",
  null
  
)

export default component.exports